import { render } from "./DisplayScreen.vue?vue&type=template&id=df5a31ce&scoped=true"
import script from "./DisplayScreen.vue?vue&type=script&lang=js"
export * from "./DisplayScreen.vue?vue&type=script&lang=js"

import "./DisplayScreen.vue?vue&type=style&index=0&id=df5a31ce&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5a31ce"]])

export default __exports__